if (!customElements.get('multicolumn-slider')) {
  class MulticolumnSlider extends HTMLElement {
    constructor() {
      super();

      this.scrollList = null;
      this.prevButton = null;
      this.nextButton = null;

      this.handleScroll = this.handleScroll.bind(this);
      this.scrollPrev = this.scrollPrev.bind(this);
      this.scrollNext = this.scrollNext.bind(this);
      this.updateArrowVisibility = this.updateArrowVisibility.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (this.scrollList) {
        this.scrollList.removeEventListener('scroll', this.handleScroll);
      }
      if (this.prevButton) {
        this.prevButton.removeEventListener('click', this.scrollPrev);
      }
      if (this.nextButton) {
        this.nextButton.removeEventListener('click', this.scrollNext);
      }
    }

    init() {
      const wrapper = this.querySelector('.hs-multicolumn-new__slider-wrapper');
      if (!wrapper) return;

      this.scrollList = wrapper.querySelector('.hs-multicolumn-new__list--scroll');
      this.prevButton = wrapper.querySelector('[data-scroll-prev]');
      this.nextButton = wrapper.querySelector('[data-scroll-next]');

      if (!this.scrollList || !this.prevButton || !this.nextButton) return;

      this.checkScrollNeeded();

      this.scrollList.addEventListener('scroll', this.handleScroll);
      this.prevButton.addEventListener('click', this.scrollPrev);
      this.nextButton.addEventListener('click', this.scrollNext);

      this.updateArrowVisibility();

      window.addEventListener('resize', () => {
        this.checkScrollNeeded();
        this.updateArrowVisibility();
      });
    }

    checkScrollNeeded() {
      if (!this.scrollList) return;

      const hasScroll = this.scrollList.scrollWidth > this.scrollList.clientWidth;

      if (hasScroll) {
        this.prevButton?.classList.add('is-visible');
        this.nextButton?.classList.add('is-visible');
      } else {
        this.prevButton?.classList.remove('is-visible');
        this.nextButton?.classList.remove('is-visible');
      }
    }

    handleScroll() {
      this.updateArrowVisibility();
    }

    updateArrowVisibility() {
      if (!this.scrollList || !this.prevButton || !this.nextButton) return;

      const scrollLeft = this.scrollList.scrollLeft;
      const maxScroll = this.scrollList.scrollWidth - this.scrollList.clientWidth;

      if (scrollLeft <= 1) {
        this.prevButton.classList.remove('is-visible');
      } else {
        this.prevButton.classList.add('is-visible');
      }

      if (scrollLeft >= maxScroll - 1) {
        this.nextButton.classList.remove('is-visible');
      } else {
        this.nextButton.classList.add('is-visible');
      }
    }

    scrollPrev() {
      if (!this.scrollList) return;

      const items = this.scrollList.querySelectorAll('.hs-multicolumn-new-item');
      if (items.length === 0) return;

      const itemWidth = items[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.scrollList).gap) || 0;
      const scrollAmount = itemWidth + gap;

      this.scrollList.scrollBy({
        left: (-scrollAmount / 2),
        behavior: 'smooth'
      });
    }

    scrollNext() {
      if (!this.scrollList) return;

      const items = this.scrollList.querySelectorAll('.hs-multicolumn-new-item');
      if (items.length === 0) return;

      const itemWidth = items[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.scrollList).gap) || 0;
      const scrollAmount = itemWidth + gap;

      this.scrollList.scrollBy({
        left: (scrollAmount / 2),
        behavior: 'smooth'
      });
    }
  }

  customElements.define('multicolumn-slider', MulticolumnSlider);
}
